<div class="nav">
  <a href="//rivethealth.com"><logo [compact]="true" [size]="24"></logo></a>
</div>
<div class="login">
  <fading-router-outlet></fading-router-outlet>
</div>
